export enum EMediaType {
  Image = 'image',
  Video = 'video',
}
